<template>
  <section class="main-block" :class="{sea: $area === 'komoe-sea'}">
    <section class="main-tit">
      <div class="tit-des">{{ $t('terms.des') }}</div>
      <template v-if="$area === 'komoe-sea'">
        <div class="tit-des-s" v-if="globalLang === 'en'">
          (user agreement, privacy policy) 
        </div>
        <div class="tit-des-s" v-if="globalLang === 'th'">
          (ข้อตกลงผู้ใช้บัญชี นโยบายความเป็นส่วนตัว) 
        </div>
      </template>
      <span class="tit-slice"></span>
      <div class="tit-en-des" v-if="$area !== 'komoe-sea'">{{ $t('terms.enDes') }}</div>
    </section>
    <component :is="comp" />
  </section>
</template>

<script>
import comp_en from './en.vue'
import comp_zh from './zh.vue'
import comp_zhs from './cn.vue'
import comp_th from './th.vue'
import comp_vi from './vi.vue'

export default {
  components: {
    comp_en,
    comp_zh,
    comp_zhs,
    comp_th,
    comp_vi
  },
  computed: {
    comp() {
      let temp;
      switch(this.globalLang) {
        case 'en':
          temp = 'comp_en';
          break;
        case 'zh':
          temp = 'comp_zh';
          break;  
        case 'th':
          temp = 'comp_th';
          break; 
        case 'vi':
          temp = 'comp_vi';
          break;   
        case 'cn':
          temp = 'comp_zhs';
          break;
        default:
          temp = 'comp_en';
      }

      return temp;
    }
  }
}
</script>

<style lang="scss" scoped>
.main-block {
  &.sea {
    .tit-des {
      font-weight: bold;
    }
    .main-tit {
      border: none;
    }
    /deep/ .main-con .con-tit {
      padding-top: 30px;
    }
  }
}
.tit-des-s {
  margin-top: 10px;
}
</style>


